import { useTranslation } from 'react-i18next';
import { Box, styled, Text } from 'shell/components';

const FileViewer = ({ docUrl, fileType }) => {
    const { t } = useTranslation('assignment');

    switch (fileType) {
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return (
                <iframe
                    title={'file'}
                    src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(docUrl)}`}
                    width={'100%'}
                    height={'100%'}
                />
            );
        default:
            return (
                <RootBox>
                    <CustomBox>
                        <Text>{t('grading-section.document-preview.no-file', 'No Viewable File')}</Text>
                    </CustomBox>
                </RootBox>
            );
    }
};

const RootBox = styled(Box)(({ theme }) => {
    return {
        margin: '16px',
        border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        width: 'calc(100% - 32px)',
        height: '80vw',
        background: theme.palette.ensightful.neutral[200],
        overflow: 'auto',
    };
});

const CustomBox = styled(Box)(() => {
    return {
        height: '100%',
    };
});

export default FileViewer;
